var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('v-container',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"d-none d-lg-block",attrs:{"lg":"3"}},[_c('sidemenu')],1),_c('v-col',{staticClass:"pt-0",attrs:{"cols":"12","lg":"9"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }